import { StyledH2 } from "@aureskonnect/react-ui";
import React from "react";

import { t } from "i18next";

import OrdersTimePreparation from "./OrdersTimePreparation";
import OrdersMinimalPrice from "./OrdersMinimalPrice";
import OrdersDiffer from "./OrdersDiffer";
import OrdersInterrupt from "./OrdersInterrupt";

export default function Orders({ selectedRows }: any) {
    return (
        <div
            style={{
                overflowY: "auto",
                paddingBottom: "200px",
                maxHeight: "90vh",
            }}
        >
            <StyledH2
                style={{
                    font: "normal normal 400 27px/41px Segoe UI",
                    color: "#000000",
                    opacity: "1",
                }}
                className="ml-5 pt-3"
            >
                {t("Configuring commands")}
            </StyledH2>
            <OrdersTimePreparation selectedRows={selectedRows} />
            <div
                className="border-footer__clz"
                style={{ paddingTop: "14px" }}
            />
            <OrdersMinimalPrice selectedRows={selectedRows} />
            <div
                className="border-footer__clz"
                style={{ paddingTop: "14px" }}
            />
            <OrdersInterrupt selectedRows={selectedRows} />
            <div className="border-footer__clz" />
            <OrdersDiffer selectedRows={selectedRows} />
        </div>
    );
}

export const ErrorMessage = (props: { message: string; fontSize: string }) => (
    <div
        style={{
            marginTop: "3rem",
            fontSize: `${props.fontSize}%`,
            color: "#f46a6a",
            marginLeft: "-110px",
        }}
    >
        {props.message}
    </div>
);
